import React, { useMemo } from 'react';

import { useMe } from '@/shared';

import { OnchainContainer } from './styled';
import { OnchainActivityRow, IRoundStat } from './onchain-activity-row';

export const OnChain: React.FC = () => {
  const { data, userPointBalance } = useMe();

  const rounds: IRoundStat[] = useMemo(() => {
    const roundsSettings: IRoundStat[] = [];
    roundsSettings.push({
      label: 'Qualification Round FAN tokens',
      value: data?.balance[1]?.balance ?? 0,
      total: userPointBalance,
      iconFill: '#FB6F6A'
    });
    if(window.config.rounds == '2') {
      roundsSettings.push({
        label: 'Round 2 FAN tokens',
          value: data?.balance[2]?.balance ?? 0,
        total: userPointBalance,
        iconFill: '#A0B3FF'
      });
    }
    return roundsSettings;
  }, [data?.balance]);

  return (
    <OnchainContainer>
      <OnchainActivityRow label="Fan points" value={userPointBalance} />

      {rounds.map((r, idx) => (
        <OnchainActivityRow
          key={`${r.label}-${idx}`}
          label={r.label}
          value={r.value}
          total={r.total}
          iconFill={r.iconFill}
        />
      ))}
    </OnchainContainer>
  );
};
